/**
 * Ask feature — suggested prompts + role UI helpers
 * -------------------------------------------------
 * Answers are generated dynamically via POST /desktop/nova/chat.
 * Context is loaded server-side from live account/location data.
 *
 * Roles: "enterprise_admin" | "manager" | "mentor" | "mentee"
 */

export const SUGGESTED_PROMPTS = {
  enterprise_admin: [
    "What locations are using the platform?",
    "Which locations have the lowest engagement?",
    "How are my mentoring teams doing overall?",
    "What mentors need more help?",
    "Which locations are falling behind?",
    "Who hasn't logged in 30+ days?",
    "Which locations have the highest completion rates?",
    "How is {location} performing compared to others?",
    "Are there mentors without any active mentees?",
    "How many active users do we have this month?",
    "What pathways have the lowest completion rates?",
    "How many technicians have completed certification this quarter?",
    "How do I add a new location?",
    "How do I create a new pathway?",
    "How do I add a new OEM program?",
    "How do I export platform-wide reports?",
    "How do I adjust user permissions?",
    "How do I onboard a new dealership?",
    "How do I add a new Manager?",
    "How do I deactivate a location?",
    "How do I generate a certification report?",
  ],
  manager: [
    "Which mentees need help?",
    "Which mentees haven't logged anything in the system?",
    "Who is falling behind on their pathway?",
    "Which mentors haven't approved reps in a while?",
    "How is my team performing this month vs last month?",
    "What's my team's completion rate?",
    "Who is closest to finishing their certification?",
    "How many reps has my team logged this week?",
    "Are all my mentors actively engaged?",
    "Which mentor-mentee pairs are struggling?",
    "Who do I need to follow up with today?",
    "What's blocking {mentee1}'s progress?",
    "How many mentees does each mentor have?",
    "How do I add a mentor?",
    "How do I add a mentee?",
    "How do I assign a mentee to a mentor?",
    "How do I reassign a mentee to a different mentor?",
    "How do I view progress reports?",
    "How do I remove an inactive user?",
    "How do I set a new mentee goal?",
  ],
  mentor: [
    "What mentees need help?",
    "What does {mentee1} need to complete?",
    "Which of my mentees haven't logged in recently?",
    "Who is ready to move to the next level?",
    "How many reps has {mentee2} completed this month?",
    "What reps are pending my approval?",
    "What skills has {mentee3} struggled with?",
    "How many mentees am I currently assigned?",
    "Who needs the most attention right now?",
    "I need to review {mentee4}'s reps",
    "How do I review a repetition?",
    "How do I approve a rep?",
    "How do I reject a rep submission?",
    "How do I view my mentee's progress reports?",
    "How do I give my mentee feedback?",
    "How do I sign off on a competency?",
  ],
  mentee: [
    "How many reps do I need for {skill}?",
    "What skills do I still need for my current level?",
    "How close am I to finishing my pathway?",
    "What's my next milestone?",
    "How many more reps until I earn reward?",
    "Did I earn anything this month?",
    "Has my mentor approved my recent reps?",
    "How do I add a repetition?",
    "I cannot find a skill set",
    "How do I upload a certification?",
    "How do I log hours?",
    "How do I view my full pathway?",
    "How do I update my profile?",
    "Why isn't my rep showing up?",
  ],
};

export const ROLE_SUBTITLE = {
  enterprise_admin: "Quick answers about your network, locations, and reviews.",
  manager: "Quick answers about your team.",
  mentor: "Quick answers about your mentees.",
  mentee: "Quick answers about your pathway.",
};

export const ROLE_ACCENT = {
  enterprise_admin: "#00ACEE",
  manager: "#009118",
  mentor: "#795EFF",
  mentee: "#00ACEE",
};



// WEBPACK FOOTER //
// ./src/components/manager/askResponders.js